var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-6 pt-4" },
    [
      _c("v-text-field", {
        staticClass: "mx-4",
        attrs: {
          "prepend-inner-icon": "mdi-magnify",
          label: "Buscar",
          "single-line": "",
          "hide-details": "",
          "validate-on-blur": ""
        },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return (function() {
              return _vm.findCustomers()
            })($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "append-outer",
            fn: function() {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "green", dark: "" },
                    on: {
                      click: function() {
                        return _vm.findCustomers()
                      }
                    }
                  },
                  [_vm._v(" Buscar ")]
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.search,
          callback: function($$v) {
            _vm.search = $$v
          },
          expression: "search"
        }
      }),
      _c("v-data-table", {
        attrs: {
          "footer-props": {
            itemsPerPageOptions: _vm.itemsPerPage,
            itemsPerPageText: "Cantidad de clientes por página",
            prevIcon: "",
            nextIcon: "",
            pageText: ""
          },
          "items-per-page": _vm.limit,
          items: _vm.view.customers.results,
          headers: _vm.headers,
          options: _vm.pageOptions,
          loading: _vm.isLoading,
          "loading-text": "Obteniendo los clientes, espere un momento por favor"
        },
        on: {
          "update:options": function($event) {
            _vm.pageOptions = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "no-data",
            fn: function() {
              return [_vm._v("No hay datos disponibles")]
            },
            proxy: true
          },
          {
            key: "no-results",
            fn: function() {
              return [_vm._v(" No se encontraron resultados ")]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "tr",
                  {
                    on: {
                      click: function($event) {
                        return _vm.changeCustomer(item)
                      }
                    }
                  },
                  [
                    !_vm.hideCheck
                      ? _c(
                          "td",
                          { staticClass: "mt-0 pt-0" },
                          [
                            _c("v-checkbox", {
                              staticClass: "mt-0 pt-0",
                              attrs: {
                                primary: "",
                                "hide-details": "",
                                "input-value":
                                  _vm.customerSelected.id == item.id
                              },
                              on: {
                                click: function($event) {
                                  return _vm.changeCustomer(item)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("td", { staticClass: "text-xs-right" }, [
                      _vm._v(_vm._s(item.name))
                    ]),
                    _c("td", { staticClass: "text-xs-right" }, [
                      _vm._v(_vm._s(item.rif))
                    ])
                  ]
                )
              ]
            }
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "grey lighten-4 ma-0 py-2" },
        [
          _c("v-pagination", {
            attrs: { length: _vm.view.customers.pages, "total-visible": 7 },
            on: {
              input: function() {
                return _vm.changePage()
              }
            },
            model: {
              value: _vm.page,
              callback: function($$v) {
                _vm.page = $$v
              },
              expression: "page"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }